import { type EpgDate } from '$/epg/dates'
import { epgProgramsModel } from '$/epg/programs'
import { type LiveChannel } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'
import { features } from '~/core/flags'
import { epgDateToRange } from './lib'

// load epg for given channels and date
export const load = createEvent<{ channels: LiveChannel[]; date: EpgDate }>()

// load programs
sample({
  clock: load,
  source: { epgSettings: features.$epgSettings },
  fn: ({ epgSettings }, { channels, date }) => {
    const { pastHours, futureHours } = epgSettings || {}
    return {
      channels,
      period: epgDateToRange(date, pastHours, futureHours),
    }
  },
  target: epgProgramsModel.fetchEpg,
})
